import { gql } from 'urql';

export const LIST_USERS_QUERY = gql`
  query ListUsersForSessions {
    listUsers: usuarios {
      id
      nombre
      apellido
      email
    }
  }
`;

export const LIST_SESSIONS_QUERY = gql`
  query ListSessionsByUser($userId: ID!) {
    listSessions(userId: $userId) {
      id
      ip
      userAgent
      creadoEn
      expiraEn
      revocado
    }
  }
`;
